import { render, staticRenderFns } from "./ProductPPLimg.vue?vue&type=template&id=1b71ddc4&"
import script from "./ProductPPLimg.vue?vue&type=script&lang=js&"
export * from "./ProductPPLimg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports